import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/InventoryMovementBrandLevel';
/*import Table from '../../Tables/DataTable/components/DataTable';*/
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const InventoryMovementBrandLevel = ({ t }) => (
  <Container>
    <Row>
      <Col md={12} style = {{marginBottom : "-15px"}}>
        <h3 className="page-title"> </h3>
      </Col>
    </Row>
       
    <Row>
      <HorizontalForm />
    </Row>

   
  </Container>
);

InventoryMovementBrandLevel.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(InventoryMovementBrandLevel);
